import {
  birthdateValidator,
  makeRequired,
} from '../../../../../OUI/Inputs';

export const birthdateFieldValidator = makeRequired(birthdateValidator);
